import { flatten, sortBy } from 'lodash-es'
import type { RouteRecordRaw } from 'vue-router'

// * 使用 import.meta.glob 动态导入除 index.ts 外的所有路由配置文件
// const routeFiles = import.meta.glob<true, string, RouteRecordRaw[]>(['./*.ts', '!./index.ts', '!./teams.ts'], { import: 'default', eager: true })
const routeFiles = import.meta.glob<true, string, RouteRecordRaw[]>(['./*.ts', '!./index.ts'], { import: 'default', eager: true })

// * 使用 lodash-es 的 flatten 和 sortBy 方法简化逻辑
const routes: RouteRecordRaw[] = sortBy(flatten(Object.values(routeFiles)), route => route.meta?.order ?? 0)

export default routes
